"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardNavigation = void 0;
var KeyboardNavigation;
(function (KeyboardNavigation) {
    KeyboardNavigation["GAMEBOARD"] = "KeyA";
    KeyboardNavigation["PLAYERSOVERVIEW"] = "KeyS";
    KeyboardNavigation["HAND"] = "KeyD";
    KeyboardNavigation["COLONIES"] = "KeyF";
})(KeyboardNavigation = exports.KeyboardNavigation || (exports.KeyboardNavigation = {}));
